import { FormEvent, useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import {
  IdentityA11yAnnouncer,
  IdentityButton,
  IdentityError as IdentityErrorView,
  IdentityFooterInline,
  IdentityHero,
  IdentityLayout,
  IdentitySuccess,
} from "@speedycore/identity-ui";
import { identityResetPassword } from "../lib/identityApi";

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = useMemo(() => params.get("token") || "", [params]);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [a11y, setA11y] = useState<string>("");

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (!token) {
      setError("Missing reset token. Use the link from your email.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }
    if (password.length < 8) {
      setError("Password too short");
      return;
    }
    setBusy(true);
    try {
      await identityResetPassword(token, password);
      setDone(true);
      setA11y("Password updated. You can sign in now.");
    } catch (err) {
      const msg = err instanceof Error ? err.message : "Reset failed.";
      setError(msg);
      setA11y(msg);
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <IdentityA11yAnnouncer message={a11y} type={error ? "error" : "success"} />
      <IdentityLayout
        hero={
          <IdentityHero
            title="Reset your SpeedyCore password"
            subtitle="Choose a new password for your SpeedyCore account."
          />
        }
        form={
          <>
            {done ? (
              <>
                <IdentitySuccess message="Password updated. You can sign in now." />
                <div className="sc-identity-links" style={{ marginTop: "1rem" }}>
                  <Link to="/auth/login">Sign in</Link>
                </div>
              </>
            ) : (
              <form className="sc-identity-form" onSubmit={(e) => void onSubmit(e)} noValidate>
                <label>
                  New password
                  <input
                    type="password"
                    autoComplete="new-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    minLength={8}
                  />
                </label>
                <label>
                  Confirm password
                  <input
                    type="password"
                    autoComplete="new-password"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    required
                    minLength={8}
                  />
                </label>
                {error ? <IdentityErrorView message={error} /> : null}
                <IdentityButton type="submit" label="Update password" loading={busy} />
              </form>
            )}
            <IdentityFooterInline />
          </>
        }
      />
    </>
  );
}
